/** Presentation preferences belong to one paired TV; transport belongs to the room. */
export const TV_MUSIC_READ = 'tv:music:read';
export const TV_MUSIC_UPDATE = 'tv:music:update';
export const TV_MUSIC_STATE = 'tv:music:state';
export type TvMusicOverlay = 'none' | 'lyrics' | 'playlist';
export interface TvMusicSettings { overlay: TvMusicOverlay; enabled: boolean; volume: number; revision: number }
export interface TvMusicChange { overlay?: Exclude<TvMusicOverlay, 'none'>; visible?: boolean; enabled?: boolean; volume?: number }
export const DEFAULT_TV_MUSIC: TvMusicSettings = { overlay: 'none', enabled: true, volume: 1, revision: 0 };
export function isTvMusicChange(value: unknown): value is TvMusicChange {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const v = value as Record<string, unknown>;
  return Object.keys(v).length > 0 && Object.keys(v).every(key => ['overlay', 'visible', 'enabled', 'volume'].includes(key))
    && (v.overlay === undefined ? v.visible === undefined : typeof v.overlay === 'string' && ['lyrics', 'playlist'].includes(v.overlay) && typeof v.visible === 'boolean')
    && (v.enabled === undefined || typeof v.enabled === 'boolean')
    && (v.volume === undefined || typeof v.volume === 'number' && Number.isFinite(v.volume) && v.volume >= 0 && v.volume <= 1);
}
export function isTvMusicSettings(value: unknown): value is TvMusicSettings {
  if (!value || typeof value !== 'object') return false;
  const v = value as TvMusicSettings;
  return ['none', 'lyrics', 'playlist'].includes(v.overlay) && typeof v.enabled === 'boolean'
    && typeof v.volume === 'number' && Number.isFinite(v.volume) && v.volume >= 0 && v.volume <= 1
    && Number.isSafeInteger(v.revision) && v.revision >= 0;
}
